const borderWidths = {
  thin: "1px",
  default: "2px",
  thick: "5px",
};

export default borderWidths;
